import { DataList } from './data-list'
import { CursorMillis } from '../timeline/timeline-common';
import { Geodetic, Coordinate } from '../map/map-types'
import { Geometry } from '../modeling/modeling-common';

export interface DataSourceOptions {
  name: string,
  url?: string,
  query?: string,
  notTemporal?: boolean,  // defaults to false
  abortDataRequest?: boolean //abort running data request when new one comes in; defaults to true
}

export enum AnimationMode {
  always = 'always',
  under = 'under',
  earlier = 'earlier',
  later = 'later'
}

export interface DataProvider { 
  getData: ( animationPosition?: CursorMillis, animationMode?: AnimationMode) => Datum[]
  getMeta: () => MetaData
}

export type DataMap = { [key: string]: DataProvider };

export type AnimationMap = { [key: string]: AnimationMode };

export interface TemporalRange {
  start: number,
  end: number
}
export interface TemporalCoordinate extends TemporalRange {
  time: number
}
export interface TemporalDataCoordinate extends TemporalCoordinate {
}


export interface SpatialBounds {
  north: number,
  east: number,
  south: number,
  west: number
}

export interface SpatialCoordinate extends SpatialBounds{
  lat: number,
  lng: number
}
/**
 * @property representsLocaction when present and true, the datum represents a point 
 * @property holdsCoordinates when present and true, the datum has spatial properties
*/
export interface SpatialDataCoordinate extends SpatialCoordinate{
  geometry?:  any
}

export interface Datum extends SpatialDataCoordinate, TemporalDataCoordinate  {
  id: string,
  version?: number,
  selected?: boolean,
  timeSeries?: DataList //TODO in the future this will hold timeSeries data (like sensor values)
  active:boolean,
  deleted: boolean
}

export interface LocationTime{
	location: Geodetic;
	time: number;
}

/**
 * A minimalistic interface for typed datum definitions
 */
export interface TypedDatumDefinition {
  id: string,
  label: string,
  icon: string
}
export interface MapOverlayDatumReader {
  isPoint: (datum: any) => boolean,
  getLat: (datum: any) => number,
  getLng: (datum: any) => number,
  getNorth: (datum: any) => number,
  getEast: (datum: any) => number,
  getSouth: (datum: any) => number,
  getWest: (datum: any) => number,
  compareByLocation: (datum0: SpatialCoordinate, datum1: SpatialCoordinate) => number,
  spatialHash: (datum: Datum) => string
}
export interface TimelineOverlayDatumReader {
  isMoment: (datum: any) => boolean,
  getTime: (datum: any) => number,
  getStart: (datum: any) => number,
  getEnd: (datum: any) => number,
  compareByTime: (datum0: TemporalCoordinate, datum1: TemporalCoordinate) => number,
  temporalHash: (datum: Datum) => string
}
export interface DatumReader extends TimelineOverlayDatumReader, MapOverlayDatumReader {
  getVersion: (datum: any) => number,
  isTemporal: (datum: any) => boolean,
  isRange: (datum: any) => boolean,
  isPerpetual: (datum: any) => boolean,
  isSince: (datum: any) => boolean,
  isUntil: (datum: any) => boolean,
  hasStart: (datum: any) => boolean,
  hasEnd: (datum: any) => boolean,
  getDuration: (datum: any) => number,
  isSpatial: (datum: any) => boolean,
  isArea: (datum: any) => boolean
  isVersional: (datum: any) => boolean,
}
export interface MetaData extends SpatialBounds, TemporalRange {
    version: number,
    lastUpdate: number,
    selected: string[]
}
